import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <FAQSection />
        <CommentsSection />
        <MediaSection />
        <IndexSection />
        <AboutSection />
        <UpdatesSection />
        <CardsSection />
        <ContactSection />
        <AppSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}